import React from 'react';
import { Table, Loading, LabelDate } from '../../../../../components';
import type { http_VisitItem } from '../../../../../services/url-shortener';

type VisitDetailsTabProps = {
  visits: http_VisitItem[];
  loading: boolean;
  error: boolean;
  sort?: SortState<'country' | 'visited_at'>;
  onSort: (newSort: string) => void;
};

export const VisitDetailsTab: React.FC<VisitDetailsTabProps> = ({
  visits,
  loading,
  error,
  sort,
  onSort,
}) => {
  const visitsColumns = [
    {
      header: 'IP Address',
      cellClassName: 'min-w-[10rem] text-left',
      getValue: ({ ip }: { ip?: string }) => (
        <span className="text-mainText">{ip || '-'}</span>
      ),
    },
    {
      sortName: 'country',
      header: 'Country',
      cellClassName: 'min-w-[8rem] text-left',
      getValue: ({ country }: { country?: string }) => (
        <span className="text-mainText">{country || '-'}</span>
      ),
    },
    {
      sortName: 'visited_at',
      header: 'Visited At',
      cellClassName: 'min-w-[15rem] text-left',
      getValue: ({ visited_at }: { visited_at?: any }) => {
        if (!visited_at) return <span className="text-secondary">-</span>;
        return (
          <LabelDate date={visited_at} showTime formatDate="dd/MMM/yyyy" />
        );
      },
    },
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[20rem]">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[20rem]">
        <span className="text-danger">
          Failed to load visit details. Please try again.
        </span>
      </div>
    );
  }

  return (
    <div>
      <Table
        data={visits || []}
        loading={loading}
        emptyMessage="No visits found"
        isCustom
        cellsClassName="py-2"
        sort={sort as SortState<string> | undefined}
        onSort={onSort}
        config={{
          columns: visitsColumns,
        }}
      />
    </div>
  );
};
